var map = {
	"./_logo-gerencia-dark.svg": 7509,
	"./_logo-gerencia-light.svg": 9587,
	"./_logo-impay.png": 2322,
	"./_logo-impay.svg": 4764,
	"./_logo-instMix.png": 3812,
	"./_logo-pix.svg": 7451,
	"./logo-gerencia-dark.webp": 5749,
	"./logo-gerencia-white.webp": 4726,
	"./logo-im-white.webp": 1824,
	"./logo-impay-colored.webp": 1217,
	"./logo-impay.webp": 7250,
	"./logo-pix.webp": 9003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;